import styled, { css } from 'styled-components'
import { device, fonts } from '../../../styles/GlobalVariables'

interface HeartButtonProps {
  isFilled: boolean
}

export const RailItemFirsItemWrap = styled.div`
  position: relative;
  ${device.medium} {
    display: flex;
    flex-direction: column;
    max-width: 1348px;
  }
`

export const PlayerWrap = styled.div`
  ${device.medium} {
    max-width: 1348px;
    background: #000;
    display: flex;
    flex-direction: column;
  }

  @media only screen and (max-width: 768px) {
    gap: 32px;
  }
`

export const RailFirstItemImage = styled.div`
  align-self: center;
  position: relative;
  max-width: 1120px;
  z-index: 1;
  background-repeat: no-repeat;
  background-size: cover;
  ${props =>
    props.theme.background
      ? css`
          background-image: url('${props.theme.background}');
        `
      : ''};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media only screen and (max-width: 768px) {
    width: 100vw;
    height: calc(100vw * 9 / 16);
  }

  ${device.medium} {
    .playkit-player {
      width: 100%;
      margin: 0 auto;
      background-image: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 58.34%,
        rgba(0, 0, 0, 0.8) 100%
      );
    }

    .playkit-seek-bar {
      width: 90%;
      margin: 0 auto;
    }

    .playkit-player .playkit-seek-bar .playkit-progress-bar .playkit-progress {
      background-color: #fff;
    }
  }
`

export const RailFirstItemDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-left: 0;
  align-items: center;
  width: 100%;
  justify-content: start;
  margin-top: 40px;
  padding-right: 10px;

  ${device.medium} {
    position: absolute;
    justify-content: end;
    align-items: center;
    bottom: 0;
    width: 100%;
    right: 0;
    padding-right: 7px;
    padding-top: 50px;
    height: 0;
  }
`

export const RailFirstItemDescriptionBellowPlayer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0;
  align-items: center;
  width: 100%;
  justify-content: start;
  margin-top: 30px;
  max-width: 100%;
  padding-left: 25.5px;
  padding-right: 25.5px;

  ${device.medium} {
    display: flex;
    justify-content: end;
    padding-right: 5.73vw;
    background: transparent;
    margin-top: 40px;
  }
`

export const CommentItemText = styled.h2`
  ${device.medium} {
    color: rgba(255, 255, 255, 0.8);
    text-align: right;
    font-family: ${fonts.default};
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.6px;
    margin-bottom: 18px;
    word-wrap: normal;
    width: 100%;
    color: #fff;
  }

  color: rgba(255, 255, 255, 0.8);
  text-align: right;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.54px;
  width: 336px;
`

export const CommentItemTextBellowPlayer = styled.h2`
  color: rgba(255, 255, 255, 0.8);
  text-align: right;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.54px;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;

  ${device.medium} {
    font-size: 20px;
    letter-spacing: -0.6px;
    margin: 0;
  }
`

export const CommentItemDateBellowPlayer = styled.div`
  color: rgba(255, 255, 255, 0.4);
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  letter-spacing: -0.4px;

  ${device.medium} {
  }
`

export const NameItemText = styled.h1`
  ${device.medium} {
    color: #fff;
    text-align: center;
    text-shadow: 0 4px 60px rgba(255, 255, 255, 0.15);
    font-size: 25px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%; /* 37.6px */
    letter-spacing: -0.8px;
    width: 100%;
    padding-top: 15px;
  }

  color: #fff;
  text-align: right;
  text-shadow: 0 4px 40px rgba(255, 255, 255, 0.25);
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 107.143% */
  letter-spacing: -1.12px;
  display: flex;
  width: 379px;
  height: 52px;
  flex-direction: column;
  justify-content: center;
`

export const NameItemTextBellowPlayer = styled.h1`
  ${device.medium} {
    align-self: stretch;
    text-shadow: 0 4px 60px rgba(255, 255, 255, 0.15);
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 94%; /* 37.6px */
    letter-spacing: -0.8px;
    width: 100%;
    margin: 0;
  }

  color: #fff;
  text-align: right;
  text-shadow: 0 4px 40px rgba(255, 255, 255, 0.25);
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 107.143% */
  letter-spacing: -1.12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
`

export const StyledHeartButton = styled.button<HeartButtonProps>`
  background: transparent;
  border: none;
  text-align: right;
  z-index: 1;
`

export const MainRailCommits = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  width: 100%;
`
